import { createContext, useContext } from 'react';

interface SidebarContextType {
  /** True when the sidebar is visible (desktop rail or mobile drawer). */
  isOpen: boolean;
  toggle: () => void;
  close: () => void;
  /** True below the lg breakpoint — the drawer/mobile shell is active. */
  isMobile: boolean;
}

export const SidebarContext = createContext<SidebarContextType | null>(null);

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};
